import PropTypes from "prop-types";
import { useWatch } from "react-hook-form";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormCombobox, FormToggle } from "components/BaseForm";
import RenderEmailTemplatePreviewModal from "routes/email/components/RenderEmailTemplatePreviewModal";

/**
 * One sending provider: whether the template is offered for it, and a preview
 * rendered for it. The footer only frames the preview and is never saved.
 */
const RenderEmailTemplate = ({ provider, template, footerOptions }) => {
  const isEnabled = useWatch({ name: `provider_list.${provider.id}` });
  const footerId = useWatch({ name: `footer_ids.${provider.id}` });

  return (
    <Card>
      <CardHeader className="tw:flex tw:flex-row tw:items-center tw:justify-between tw:gap-2">
        <CardTitle>{provider.label}</CardTitle>
        <div>
          <FormToggle
            name={`provider_list.${provider.id}`}
            aria-label={`Enable ${provider.label}`}
          />
        </div>
      </CardHeader>
      {isEnabled && (
        <CardContent>
          <div className="tw:flex tw:flex-wrap tw:items-end tw:gap-3">
            <div className="tw:min-w-64 tw:flex-1">
              <FormCombobox
                name={`footer_ids.${provider.id}`}
                id={`footer-${provider.id}`}
                label="Footer"
                options={footerOptions}
                placeholder="No footer"
                clearable
              />
            </div>
            <RenderEmailTemplatePreviewModal
              template={template}
              footerId={footerId ?? undefined}
              providerId={provider.id}
            />
          </div>
        </CardContent>
      )}
    </Card>
  );
};

RenderEmailTemplate.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  template: PropTypes.object.isRequired,
  footerOptions: PropTypes.array.isRequired,
};

export default RenderEmailTemplate;
